import AssessmentsAdapter from './base';
import {
  deleteRecordWithAuditReason,
  updateRecordWithAuditReason,
} from 'linced-app/utils/auditing';

export default class Grade extends AssessmentsAdapter {
  modelNamePlural = 'grades';
  deleteRecord = deleteRecordWithAuditReason;
  updateRecord = updateRecordWithAuditReason;
}
